export default __webpack_public_path__ + "static/race-day-relay-square-269ec3d31a5f4bb9908ec6967e45fa33.png";